// Discriminator sent on the polymorphic Booking payload to mark a room booking. The generated
// client types it as a plain `string`, so it is not inferred — we set it explicitly when building
// a request. Shared occurrence/recurrence constants live in `../Bookings/shared`.
export const ROOM_BOOKING_TYPE = 'ROOM' as const;
